import { createSlice } from '@reduxjs/toolkit';

import {
  syncCatalogFromListingsReducers,
  getCatalogSyncStatusReducers,
  skuManagementSettingsReducers,
  ebayEnrichmentReducers,
  ebaySkuDataSyncReducers,
  skuItemsOverviewReducers,
  skuItemsPageReducers,
} from './sku-management.reducers';

const initialState = {
  syncCatalogFromListingsStatus: 'idle',
  lastCatalogSyncResponse: null,
  getCatalogSyncStatus: 'idle',
  catalogSyncStatus: null,
  error: null,

  getSkuManagementSettingsStatus: 'idle',
  updateSkuManagementSettingsStatus: 'idle',
  skuManagementSettings: null,
  settingsError: null,

  getEbayEnrichmentStatusRequest: 'idle',
  startEbayEnrichmentStatus: 'idle',
  ebayEnrichmentStatus: null,
  lastEbayEnrichmentStartResponse: null,
  ebayEnrichmentError: null,

  getEbaySkuDataSyncStatusRequest: 'idle',
  startEbaySkuDataSyncStatus: 'idle',
  ebaySkuDataSyncStatus: null,
  lastEbaySkuDataSyncStartResponse: null,
  ebaySkuDataSyncError: null,

  getSkuItemsOverviewStatus: 'idle',
  skuItemsOverview: null,
  getSkuItemsPageStatus: 'idle',
  skuItemsPage: null,
  itemsPageError: null,
};

const skuManagementSlice = createSlice({
  name: 'skuManagement',
  initialState,
  reducers: {
    clearSkuManagementError: (state) => {
      state.error = null;
      state.settingsError = null;
      state.ebayEnrichmentError = null;
      state.ebaySkuDataSyncError = null;
      state.itemsPageError = null;
    },
  },
  extraReducers: (builder) => {
    getCatalogSyncStatusReducers(builder);
    syncCatalogFromListingsReducers(builder);
    skuManagementSettingsReducers(builder);
    ebayEnrichmentReducers(builder);
    ebaySkuDataSyncReducers(builder);
    skuItemsOverviewReducers(builder);
    skuItemsPageReducers(builder);
  },
});

export const { clearSkuManagementError } = skuManagementSlice.actions;

export default skuManagementSlice.reducer;
